import firebase from 'firebase/app'
import 'firebase/firestore'

const config = {
  apiKey: 'AIzaSyDne10brMJn85ucg3RKFvKh060jtlQd4Mw',
  projectId: 'wealth-financial-planning',
}

firebase.initializeApp(config)

const db = firebase.firestore()

export default db



// WEBPACK FOOTER //
// ./src/firebase.js